export type LanguageCode = typeof LANGUAGE_OPTIONS[number]['value'];

export const LANGUAGE_OPTIONS = [
    { value: 'en', label: 'English', alias: 'English' },
    { value: 'ja', label: '日本語', alias: 'Japanese' },
    { value: 'ko', label: '한국어', alias: 'Korean' },
    { value: 'fr', label: 'Français', alias: 'French' },
    { value: 'es', label: 'Español', alias: 'Spanish' },
    { value: 'de', label: 'Deutsch', alias: 'German' },
    { value: 'zh-Hans', label: '简体中文', alias: 'Chinese Simplified, Mandarin' },
    { value: 'pt-BR', label: 'Português', alias: 'Portuguese - Brazil' }
] as const satisfies readonly { value: string; label: string; alias: string }[];

